import { Col, Form, Input, Modal, Row, Select } from 'antd'
import MaskedInput from 'antd-mask-input'
import { FC } from 'react'
import styled from 'styled-components'

import { renderDigitsOnly } from 'utils/stringFormatting'

import * as T from 'types'

const AddContactModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`

interface IEditContactInfoModal {
  close: () => void
  contactInfo: T.IContactInfo
  update: (contactInfo: T.IContactInfo) => void
  title: string
}

type IContactInfoForm = {
  name: string
  email: string
  phone: string
  phoneAcceptsTexts: string
}

export const EditContactInfoModal: FC<IEditContactInfoModal> = ({
  close,
  contactInfo,
  update,
  title,
}) => {
  const [form] = Form.useForm<IContactInfoForm>()
  const submitForm = () => form.submit()

  const handleSubmit = (values: IContactInfoForm) => {
    const updatedContactInfo: T.IContactInfo = {
      ...contactInfo,
      name: values.name,
      email: values.email,
      phone: parseInt(values.phone.replace(/[^\d]/g, ''), 10),
      phoneAcceptsTexts: values.phoneAcceptsTexts === 'true',
    }

    update(updatedContactInfo)
    close()
  }

  return (
    <Modal
      title={title}
      visible={!!contactInfo}
      onOk={submitForm}
      onCancel={close}
      width={700}
    >
      <AddContactModalContainer>
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <Form.Item
                initialValue={contactInfo.name}
                label="Name"
                name="name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={12}
            >
              <Form.Item
                initialValue={contactInfo.email}
                label="Email"
                name="email"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={12}
            >
              <Form.Item
                initialValue={contactInfo.phone?.toString()}
                label="Phone"
                name="phone"
                rules={[{ required: true }]}
                normalize={renderDigitsOnly}
              >
                <MaskedInput
                  mask="111-111-1111"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                initialValue={contactInfo.phoneAcceptsTexts ? 'true' : 'false'}
                label="Text Message Accepted?"
                name="phoneAcceptsTexts"
              >
                <Select>
                  <Select.Option value="true">Yes</Select.Option>
                  <Select.Option value="false">No</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </AddContactModalContainer>
    </Modal>
  )
}
